import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import { connect } from "react-redux";
import Axios from "axios";

import PersonIcon from "@material-ui/icons/Person";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import CategoryIcon from "@material-ui/icons/Category";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import ErrorIcon from "@material-ui/icons/Error";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import FeedbackIcon from "@material-ui/icons/Feedback";

import { adminLogout } from "../../../redux/action/action";
import DashboardCard from "./DashboardCard/DashboardCard";
import NavBar from "../../../Component/NavBar/AdminHeader/AdminHeader";
import { url } from "../../../config/config";
import SessionExpiredDialog from "../../../Component/SessionExpiredDialog/SessionExpiredDialog";
import { useStyles } from "./Dashboard.css";
import AdminPageTitle from "../../../Component/AdminPageTitle/AdminPageTitle";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [
        {
          label: "User Registered",
          count: "",
          url: "/_administration_/user/view",
          icon: (
            <PersonIcon style={{ width: 50, height: 50, color: "#253570" }} />
          ),
        },
        {
          label: "Authors Registered",
          count: "",
          url: "/_administration_/author/view",
          icon: (
            <PersonIcon style={{ width: 50, height: 50, color: "#253570" }} />
          ),
        },
        {
          label: "Total Category Registered",
          count: "",
          url: "/_administration_/category/view",
          icon: (
            <CategoryIcon style={{ width: 50, height: 50, color: "#253570" }} />
          ),
        },
        {
          label: "Total Books",
          count: "",
          url: "/_administration_/book/view",
          icon: (
            <LibraryBooksIcon
              style={{ width: 50, height: 50, color: "#253570" }}
            />
          ),
        },
        {
          label: "Unapproved Books",
          count: "",
          url: "/_administration_/books/unapproved",
          icon: (
            <ErrorIcon style={{ width: 50, height: 50, color: "#253570" }} />
          ),
        },
        {
          label: "Approved Books",
          count: "",
          url: "/_administration_/books/approved",
          icon: (
            <CheckCircleIcon
              style={{ width: 50, height: 50, color: "#253570" }}
            />
          ),
        },
        {
          label: "Total Books Sold",
          count: "",
          icon: (
            <ShoppingCartIcon
              style={{ width: 50, height: 50, color: "#253570" }}
            />
          ),
        },
        {
          label: "Total Books Rented",
          count: "",
          icon: (
            <ShoppingCartIcon
              style={{ width: 50, height: 50, color: "#253570" }}
            />
          ),
        },
        {
          label: "Total Feedbacks",
          count: "",
          url: "/_administration_/feedback/view",
          icon: (
            <FeedbackIcon style={{ width: 50, height: 50, color: "#253570" }} />
          ),
        },
      ],
      sessionExpired: false,
    };
  }

  async componentDidMount() {
    try {
      const users = await Axios.get(`${url}/api/users`, {
        headers: {
          "x-auth-token": this.props.adminToken,
        },
      });
      this.setCount("User Registered", users.data.length);

      const authors = await Axios.get(`${url}/api/authors`);
      this.setCount("Authors Registered", authors.data.length);

      const category = await Axios.get(`${url}/api/categories`);
      this.setCount("Total Category Registered", category.data.length);

      const books = await Axios.get(`${url}/api/books/allBooks`, {
        headers: {
          "x-auth-token": this.props.adminToken,
        },
      });
      this.setCount("Total Books", books.data.length);

      const feedbacks = await Axios.get(`${url}/api/feedbacks`);
      this.setCount("Total Feedbacks", feedbacks.data.length);

      const unapprovedBooks = await Axios.get(`${url}/api/books/allBooks`, {
        headers: {
          "x-auth-token": this.props.adminToken,
        },
      });
      let unapprovedFilter = unapprovedBooks.data.filter(
        (item) => item.bookVerified === false
      );
      this.setCount("Unapproved Books", unapprovedFilter.length);

      const approvedBooks = await Axios.get(`${url}/api/books/allBooks`, {
        headers: {
          "x-auth-token": this.props.adminToken,
        },
      });
      let approvedFilter = approvedBooks.data.filter(
        (item) => item.bookVerified === true
      );
      this.setCount("Approved Books", approvedFilter.length);

      const soldBooks = await Axios.get(`${url}/api/sold`, {
        headers: {
          "x-auth-token": this.props.adminToken,
        },
      });
      let temp = 0;
      soldBooks.data.map((sold) => (temp = temp + sold.itemDetails.length));
      this.setCount("Total Books Sold", temp);

      const rentBooks = await Axios.get(`${url}/api/rent`, {
        headers: {
          "x-auth-token": this.props.adminToken,
        },
      });
      this.setCount("Total Books Rented", rentBooks.data.length);
    } catch (error) {
      if (error.response.data === "Invalid token.") {
        this.setState({
          sessionExpired: true,
        });
      }
    }
  }

  setCount = (label, tempCount) => {
    const newArray = this.state.data.map((data) =>
      data.label === label
        ? { ...data, count: tempCount }
        : { ...data, count: data.count }
    );
    this.setState({
      data: newArray,
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <NavBar />
        <div className={classes.root}>
          {this.state.sessionExpired === true && (
            <SessionExpiredDialog logout={() => this.props.adminLogout()} />
          )}
          <AdminPageTitle title="Dashboard" refreshUrl={this.props.match.url} />
          <Divider />
          <br />
          <Grid container spacing={3}>
            {this.state.data.map((data, index) => (
              <DashboardCard
                key={index}
                url={data.url}
                label={data.label}
                count={data.count}
                icon={data.icon}
              />
            ))}
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    adminLogout: () => {
      dispatch(adminLogout());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(Dashboard)));
